import APIFetcher from '../APIFetcher';

class UserStreamApi {
  /**
   * Get user stream by user id
   *
   * @param {string} streamName
   * @returns {Promise}
   */
  static get(streamName) {
    return APIFetcher.get(`stream/${streamName}`);
  }

  /**
   * Update latest date read on the user stream
   *
   * @param {string} streamName
   * @param {string} dateRead
   * @returns {Promise}
   */
  static post({streamName, dateRead}) {
    return APIFetcher.post(`stream/${streamName}`, {payload: {date_last_viewed: dateRead}});
  }
}

export default UserStreamApi;
